/**
 * Quick add tracking.
 *
 * Publishes a quick_add custom event to Shopify's customer events whenever a
 * product is added to the cart from a product card, so it can be forwarded to
 * GA4 by a custom pixel and reported separately from add_to_cart.
 *
 * It covers all three quick add routes on a card: the inline size picker,
 * Horizon's pop-up for products with many variants, and the direct add for
 * single variant products. Each of these fires the theme's cart:update event
 * once the add has succeeded, so this listens for that rather than changing
 * the add to cart code itself.
 *
 * Adds from the product page, the sticky add to cart and the cart drawer are
 * ignored, because they do not start inside a product card or the quick add
 * pop-up.
 */

if (!window.__pehrQuickAddTracking) {
  window.__pehrQuickAddTracking = true;

  document.addEventListener('cart:update', (event) => {
    const data = event.detail?.data;
    if (!data || data.didError) return;

    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const inModal = target.closest('.quick-add-modal');
    const inCard = target.closest('product-card, .product-grid__card, quick-add-component');
    if (!inModal && !inCard) return;

    let route = 'direct';
    if (data.source === 'quick-add-inline') route = 'inline';
    else if (inModal) route = 'modal';

    const variantId = String(data.variantId || event.detail?.sourceId || '');
    const cart = event.detail?.resource;
    const line = Array.isArray(cart?.items)
      ? cart.items.find((item) => String(item.variant_id) === variantId)
      : null;

    const path = window.location.pathname;
    const isCollectionPage = path.includes('/collections/') && !path.includes('/products/');

    const payload = {
      quick_add_type: route,
      variant_id: variantId,
      product_id: String(line?.product_id || data.productId || ''),
      product_title: line?.product_title || '',
      variant_title: line?.variant_title || '',
      price: line ? line.final_price / 100 : null,
      currency: cart?.currency || window.Shopify?.currency?.active || '',
      quantity: Number(data.itemCount) || 1,
      page_path: path,
      page_type: isCollectionPage ? 'collection' : 'other',
    };

    try {
      window.Shopify?.analytics?.publish?.('quick_add', payload);
    } catch (error) {
      console.warn('quick_add tracking failed', error);
    }
  });
}
